import { DataGrid } from "@mui/x-data-grid";
import React, { useState, useEffect } from "react";
import axios from "axios";
import "./FarmList.scss";
import BASE_URL from "../../../config/apiConfig";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
} from "@mui/material";

const FarmList = () => {
  const [data, setData] = useState([]);
  const [isViewOpen, setIsViewOpen] = useState(false);
  const [farmToView, setFarmToView] = useState(null);

  // Fetch farm data from API on component mount
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`${BASE_URL}/api/admin/farms`);
        const transformedData = response.data.map((farm) => ({
          id: farm.id,
          cropCode: farm.crop_name || "Unknown", // Use crop_name directly

          fieldId: farm.field_id,
          fieldName: farm.field_name,
          fieldArea: (farm.field_area / 10000).toFixed(2), // Convert to hectares and round to 2 decimal places
          sowingDate: farm.sowing_date
            ? new Date(farm.sowing_date).toLocaleDateString()
            : "N/A",
          email: farm.email,
          ndviUrl: farm.ndvi_url,
          aviUrl: farm.avi_url,
          socUrl: farm.soc_url,
        }));
        setData(transformedData);
      } catch (error) {
        console.error("Error fetching farm data:", error);
      }
    };

    fetchData();
  }, []);

  const handleView = (farm) => {
    setFarmToView(farm);
    setIsViewOpen(true);
  };

  const columns = [
    { field: "id", headerName: "ID", width: 100 },
    { field: "cropCode", headerName: "Crop Code", width: 150 },
    { field: "fieldId", headerName: "Field ID", width: 180 },
    { field: "fieldName", headerName: "Field Name", width: 180 },
    { field: "fieldArea", headerName: "Field Area (ha)", width: 150 },
    { field: "sowingDate", headerName: "Sowing Date", width: 150 },
    { field: "email", headerName: "Email", width: 250 },
    {
      field: "ndviUrl",
      headerName: "NDVI Image",
      width: 150,
      renderCell: (params) => (
        <img
          src={`${BASE_URL}/images/${params.value}`}
          alt="NDVI"
          className="thumbnail"
        />
      ),
    },
    {
      field: "aviUrl",
      headerName: "AVI Image",
      width: 150,
      renderCell: (params) => (
        <img
          src={`${BASE_URL}/images/${params.value}`}
          alt="AVI"
          className="thumbnail"
        />
      ),
    },
    {
      field: "socUrl",
      headerName: "SOC Image",
      width: 150,
      renderCell: (params) => (
        <img
          src={`${BASE_URL}/images/${params.value}`}
          alt="SOC"
          className="thumbnail"
        />
      ),
    },
    {
      field: "action",
      headerName: "Action",
      width: 150,
      renderCell: (params) => (
        <button
          type="button"
          className="view-button"
          onClick={() => handleView(params.row)}
        >
          View
        </button>
      ),
    },
  ];

  return (
    <>
      <h1 className="farm-list-title">Farm List</h1>
      <div className="data-table">
        <DataGrid
          className="data-grid"
          rows={data}
          columns={columns}
          pageSize={10}
          rowsPerPageOptions={[10]}
          checkboxSelection={false}
          getRowId={(row) => row.id}
        />
      </div>

      {/* MUI Dialog for Viewing Farm Details */}
      <Dialog open={isViewOpen} onClose={() => setIsViewOpen(false)}>
        <DialogTitle>Farm Details</DialogTitle>
        <DialogContent>
          {farmToView && (
            <div>
              <p>
                <strong>ID:</strong> {farmToView.id}
              </p>
              <p>
                <strong>Crop Code:</strong> {farmToView.cropCode}
              </p>
              <p>
                <strong>Field ID:</strong> {farmToView.fieldId}
              </p>
              <p>
                <strong>Field Name:</strong> {farmToView.fieldName}
              </p>
              <p>
                <strong>Field Area:</strong> {farmToView.fieldArea}
              </p>
              <p>
                <strong>Sowing Date:</strong> {farmToView.sowingDate}
              </p>
              <p>
                <strong>Email:</strong> {farmToView.email}
              </p>
              <div>
                <strong>NDVI Image:</strong>
                <img
                  src={`${BASE_URL}/images/${farmToView.ndviUrl}`}
                  alt="NDVI"
                  className="dialog-image"
                />
              </div>
              <div>
                <strong>AVI Image:</strong>
                <img
                  src={`${BASE_URL}/images/${farmToView.aviUrl}`}
                  alt="AVI"
                  className="dialog-image"
                />
              </div>
              <div>
                <strong>SOC Image:</strong>
                <img
                  src={`${BASE_URL}/images/${farmToView.socUrl}`}
                  alt="SOC"
                  className="dialog-image"
                />
              </div>
            </div>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setIsViewOpen(false)} color="secondary">
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default FarmList;
